import { Component, Inject } from "@angular/core"
import { MAT_DIALOG_DATA } from "@angular/material/dialog"
import { LexTranslateService } from "@app/core/services/lex-translate.service"

export type FeedbackVariant = "success" | "warning" | "error"

export interface FeedbackDialogData {
  title: string
  variant?: FeedbackVariant
  message?: string
  closeLabel?: string
}

// A fonte local de Material Icons é antiga e não inclui task_alt nem warning_amber
const VARIANT_ICONS: Record<FeedbackVariant, string> = {
  success: "check_circle",
  warning: "warning",
  error: "error",
}

@Component({
  selector: "seb-feedback-dialog",
  templateUrl: "./feedback-dialog.component.html",
  styleUrls: ["./feedback-dialog.component.css"],
})
export class FeedbackDialogComponent {
  readonly variant: FeedbackVariant
  readonly icon: string

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: FeedbackDialogData,
    public lextranslate: LexTranslateService
  ) {
    this.variant = data.variant ?? "success"
    this.icon = VARIANT_ICONS[this.variant]
  }
}
